import React from "react"
import { connect } from "react-redux"
import { setMobileMenuVisibility } from "home/actions"

const MobileMenuButton = ({ dispatch }) => {
  return <span className="menu-button" onClick={() => dispatch(setMobileMenuVisibility(true))} />
}

export default connect()(MobileMenuButton)
